import Alert from '@mui/material/Alert';
import { useAtom } from 'jotai';
import { useMemo } from 'react';

import { ticketAtom } from '@/pages/Ticket';
import { TICKET_STATUS } from '@/pages/Tickets/Tickets.constants';

const TicketDetailsStatusAlert = () => {
  const [{ ticket_status }] = useAtom(ticketAtom);

  const text = useMemo(() => {
    // prior to ticket being published
    if (ticket_status?.name === TICKET_STATUS.NEEDS_REVIEW) {
      return 'This ticket is awaiting a QA check.';
    }

    // prior to ticket being acknowledged
    if (ticket_status?.name === TICKET_STATUS.OPEN) {
      return 'This ticket has not yet been acknowledged.';
    }

    // ticket closed
    if (ticket_status?.name === TICKET_STATUS.COMPLETED) {
      return 'This ticket is now closed. Please note that any new comments or attachments added will not be monitored by our SOC team. If you need further assistance or wish to continue the discussion, kindly open a new ticket.';
    }

    return '';
  }, [ticket_status]);

  return <>{text && <Alert severity="warning">{text}</Alert>}</>;
};

export default TicketDetailsStatusAlert;
